export enum IntroductionDataTest {
  GET_STARTED_BUTTON = "GET_STARTED_BUTTON",
}
